<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="heading-1 mb-4">
                            <span>REQUISIÇÃO</span>
                        </h4>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <quadro-resumo-rateios
                            :requisicao="requisicao"
                        ></quadro-resumo-rateios>
                        <div class="d-flex">
                            <app-btn-voltar
                                :rota="obterRotaListagem"
                            ></app-btn-voltar>
                            <btn-enviar-solicitacao
                                @atualizarRequisicao="obterRequisicao"
                                :requisicao="requisicao"
                            />
                            <btn-cancelar-solicitacao
                                :requisicao="requisicao"
                                @atualizarRequisicao="obterRequisicao()"
                            />
                            <btn-avaliar-requisicao
                                :requisicao="requisicao"
                                @atualizarRequisicao="obterRequisicao()"
                                v-if="mostrarAvaliarRequisicao"
                            />
                        </div>

                        <b-tabs class="mt-4">
                            <b-tab title="Dados Gerais" active>
                                <requisicao-detalhes
                                    :requisicao="requisicao"
                                ></requisicao-detalhes>
                                <div class="d-flex mt-4">
                                    <b-button
                                        variant="primary"
                                        @click.stop="toAtualizar()"
                                        class="ml-2"
                                        v-if="permiteAtualizar"
                                    >
                                        <i class="fa fa-edit"></i>
                                        Atualizar</b-button
                                    >
                                </div>
                            </b-tab>
                            <b-tab title="Itens da Requisição"
                                ><requisicao-itens
                                    :requisicao="requisicao"
                                    :permiteInserirItens="permiteInserirItens"
                                    @obterRequisicaoAtualizada="obterRequisicao"
                                    :permiteExcluirItens="permiteInserirItens"
                                    :permiteAtualizarItens="permiteInserirItens"
                                    :permiteAtualizarDescontoItens="
                                        permiteInserirItens
                                    "
                                ></requisicao-itens
                            ></b-tab>
                            <b-tab title="Rateios"
                                ><requisicao-comprometimentos
                                    :contrato="requisicao.contrato"
                                    v-if="requisicao"
                                    :requisicao="requisicao"
                                    :dataServicos="dataServicos"
                                    @obterRequisicaoAtualizada="
                                        obterRequisicao()
                                    "
                                    :requisicaoDisponivel="
                                        !requisicaoIndisponivel()
                                    "
                                    :permiteOperacoes="permiteRealizarOperacoes"
                                ></requisicao-comprometimentos
                            ></b-tab>
                            <b-tab title="Histórico de análise">
                                <requisicao-analise
                                    v-if="requisicao"
                                    :requisicao="this.requisicao"
                                />
                            </b-tab>
                            <b-tab
                                title="Envios"
                                v-if="requisicao && requisicao.emailsEnvios"
                            >
                                <requisicao-envios
                                    :requisicao="requisicao"
                                ></requisicao-envios>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import RequisicaoItens from './RequisicaoItens'
import RequisicaoComprometimentos from './RequisicaoComprometimentos'
import QuadroResumoRateios from './QuadroResumoRateios'
import RequisicaoEnvios from './RequisicaoEnvios'
import RequisicaoDetalhes from './RequisicaoDetalhes'
import { situacaoRequisicao } from './SituacaoRequisicao'
import BtnEnviarSolicitacao from './BtnEnviarSolicitacao.vue'
import BtnCancelarSolicitacao from './BtnCancelarSolicitacao.vue'
import BtnAvaliarRequisicao from './BtnAvaliarRequisicao.vue'
import RequisicaoAnalise from './RequisicaoAnalise'

export default {
    components: {
        QuadroResumoRateios,
        RequisicaoItens,
        RequisicaoComprometimentos,
        RequisicaoEnvios,
        RequisicaoDetalhes,
        BtnEnviarSolicitacao,
        BtnCancelarSolicitacao,
        BtnAvaliarRequisicao,
        RequisicaoAnalise
    },

    props: {
        rotaListagem: {
            type: String
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            size1: '160',
            erros: [],
            requisicao: null,
            rotaDetalhar: this.$route.query.rotaDetalhar || null,
            emailUsuarioAtual: this.$store.getters.usuario.email
        }
    },

    methods: {
        obterRequisicao() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterPorId(this.$route.params.requisicaoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.requisicao = response.data
                        } else {
                            this.erros = ['Erro ao obter requisição']
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
        requisicaoIndisponivel() {
            if (this.requisicao) {
                return (
                    !(
                        (this.requisicao.itens.length == 0 &&
                            this.requisicao.comprometimentos.length == 0) ||
                        this.requisicao.contrato.contratoVigente
                    ) ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.CONCLUIDA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.AUTORIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.FINALIZADA ||
                    this.requisicao.codSituacao ==
                        situacaoRequisicao.ENVIO_REGISTRADO ||
                    this.requisicao.codSituacao == situacaoRequisicao.CANCELADA
                )
            }
            return true
        },
        toAtualizar() {
            this.$router.push({
                name: 'Contratos_Requisicoes_Atualizar',
                params: {
                    idRequisicao: this.requisicao.idRequisicao
                },
                query: {
                    rotaDetalhar: this.rotaDetalhar,
                    rotaListagem: this.rotaListagem
                }
            })
        }
    },

    created() {
        this.obterRequisicao()
    },
    computed: {
        permiteInserirItens() {
            return (
                (this.$temAcessoView('CONT-REQ-04') &&
                this.permiteRealizarOperacoes) || ((this.requisicao.codSituacao == 2) && (this.requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email))
            )
        },
        permiteAtualizar() {
            return this.permiteRealizarOperacoes
        },
        permiteRealizarOperacoes() {
            if (this.requisicaoIndisponivel()) return false

            if (this.requisicao) {
                if( ((this.requisicao.codSituacao == 2) && (this.requisicao.emailResponsavelDevolucao == this.$store.getters.usuario.email))){
                    return true
                }
                if (this.usuarioAtualSolicitante) {
                    const situacaoSolicitacaoCadastrada = 0
                    const situacaoSolicitacaoDevolvida = 3
                    return (
                        this.requisicao.situacaoSolicitacao ==
                            situacaoSolicitacaoCadastrada ||
                        this.requisicao.situacaoSolicitacao ==
                            situacaoSolicitacaoDevolvida
                    )
                }
                if (this.usuarioAtualUabs) {
                    const situacaoSolicitacaoAprovada = 3
                    return (
                        this.requisicao.situacaoSolicitacao ==
                        situacaoSolicitacaoAprovada
                    )
                }
            }
            return false
        },
        usuarioAtualSolicitante() {
            return this.requisicao.emailSolicitante == this.emailUsuarioAtual
        },
        usuarioAtualGestorSolicitacaoRequisicao() {
            return (
                this.requisicao.emailGestorSolicitacao == this.emailUsuarioAtual
            )
        },
        usuarioAtualUabs() {
            return this.$temAcessoView('REQ-UABS-SOL') 
        },
        obterRotaListagem() {
            if (this.rotaListagem) {
                return this.rotaListagem
            } else {
                return this.$route.query.rotaListagem
            }
        },
        mostrarAvaliarRequisicao() {
            return (
                this.requisicao &&
                this.requisicao.situacaoSolicitacao == 5 &&
                this.requisicao.usuarioAtualAnalistaGestor
            )
        }
    },

    watch: {}
}
</script>

